import {useMutation} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {apiClient} from '@common/http/query-client';
import {toast} from '@ui/toast/toast';
import {message} from '@ui/i18n/message';

export interface VerifyPhoneUpdateMobileOtpPayload {
  code: string;
  mobile_number: string;
  mobile_code: string;
}

export function useVerifyPhoneUpdateMobileOtp(
  form: UseFormReturn<VerifyPhoneUpdateMobileOtpPayload>,
) {
  return useMutation({
    mutationFn: (payload: VerifyPhoneUpdateMobileOtpPayload) => verify(payload),
    onSuccess: () => {
      toast(message('Phone number changed successfully'));
      // full reload so every part of the app (bootstrap data, cached
      // queries, etc.) picks up the new mobile number, not just the
      // account settings panel — delayed briefly so the toast above is
      // actually visible before the page unloads
      setTimeout(() => window.location.reload(), 1200);
    },
    onError: err => onFormQueryError(err, form),
  });
}

function verify(payload: VerifyPhoneUpdateMobileOtpPayload) {
  return apiClient
    .post('phone-update/verify-mobile-otp', payload)
    .then(response => response.data);
}
